module.exports = __webpack_public_path__ + "static/sacoches1-b4d17bfde8885eb2e1d9961835f6b983.jpg";